import { render } from "./ResultItem.vue?vue&type=template&id=87ff499c&ts=true"
import script from "./ResultItem.vue?vue&type=script&lang=ts"
export * from "./ResultItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__